import React from 'react';
import { RouteObject, useSearchParams } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import withAuth from '../hoc/withAuth';
import AdminLayout from '../components/layout/AdminLayout';


// Import all admin-related components
import Dashboard from '../pages/Dashboard';
import BandListPage from '../pages/BandListPage';
import PublicBandListPage from '../pages/PublicBandListPage';
import BandEditPage from '../pages/BandEditPage';
import EventListPage from '../pages/EventListPage';
import EventDetailPage from '../pages/EventDetailPage';
import EventFormPage from '../pages/EventFormPage';
import VenueListPage from '../pages/VenueListPage';
import VenueDetailPage from '../pages/VenueDetailPage';
import VenueFormPage from '../pages/VenueFormPage';
import PerformancesPage from '../pages/PerformanceListPage';
import PerformanceDetailPage from '../pages/PerformanceDetailPage';
import AddEditPerformancePage from '../pages/AddEditPerformancePage';
import PersonnelListPage from '../pages/PersonnelListPage';
import PersonnelDetailPage from '../pages/PersonnelDetailPage';
import PersonnelFormPage from '../pages/PersonnelFormPage';
import TitoApiTestPage from '../pages/TitoApiTestPage';
import TitoApiConnectionTest from '../pages/TitoConnectionTest';
import StrandListPage from '../pages/StrandListPage';
import StrandFormPage from '../pages/StrandFormPage';
import StrandDetailPage from '../pages/StrandDetailPage';
import NavigatorApplicationsList from '../pages/NavigatorApplicationsList';
import BanBamApplicationList from '../pages/BanBamApplicationList';
import BanBamApplicantDetailPage from '../pages/BanBamApplicantDetailPage';
import NavigatorApplicantDetailPage from '../pages/NavigatorApplicantDetailPage';
import UnifiedApplicationsView from '../components/UnifiedApplicationsView';
import AdminUserManagement from '../pages/AdminUserManagement';
import AdminDomainManagementPage from '../pages/AdminDomainManagementPage';
import AllProspectsPage from '../pages/AllProspectsPage';
import ExpenseListPage from '../pages/ExpenseListPage';
import ExpenseDetailPage from '../pages/ExpenseDetailPage';
import ExpenseForm from '../components/ExpenseForm';
import GuidelinesManagementPage from '../components/guidelines/GuidelinesManagementPage';
import GuidelineEditor from '../components/guidelines/GuidelineEditor';
import TicketConfigPage from '../components/TicketConfigPage';
import BandRecommendationPage from '../pages/BandRecommendationPage';
import CalendarComponent from '../components/CalendarComponent';
import PublicStrandsPage from '../pages/PublicStrandsPage';
import MondayApiTest from '../components/MondayApiTest';
import PublishedBandListPage from '../pages/PublishedBandListPage';
import StageDesignerPage from '../pages/StageDesignerPage';
import StagePlotsListPage from '../pages/Artists/StagePlotsListPage';
import StagePlotPDF from '../components/artists/StagePlotPDF';
import StrandBandView from '../components/bandpage/StrandBandView';
import MusicAdminPage from '../pages/Artists/MusicAdminPage';
import ProgrammingProspects from '../components/ProgrammingProspects';
import BanBamPage from '../pages/BanBamPage';
import FormPage from '../pages/FormPage';
import BanBam2025Announcement from '../pages/BanBam2025Announcement';
import DynamicForm from '../components/form/formbuilder/DynamicForm';
import { banBamFormSchema } from '../forms/schemas/banBamFormSchema';
import FormBuilder from '../pages/FormBuilder';
import BandContainer from '../components/bandpage/BandContainer';
import GuidelineViewPage from '../pages/GuidelineViewPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import ArtistDashboard from '../pages/Artists/ArtistDashboard';
import ArtistProfileEditPage from '../pages/Artists/ArtistProfileEditPage';
import ArtistSignupPage from '../pages/Artists/ArtistSignupPage';
import InvestorDashboard from '../pages/InvestorDashboard';
import DynamicFormPage from '../pages/DynamicFormPage';
import SubmissionSuccess from '../pages/SubmissionSuccess';
import TicketConfigurationList from '../pages/TicketConfigurationList';
import TicketConfigurationDetail from '../pages/TicketConfigurationDetail';
import TasksPage from '../pages/TasksPage';
import IdeasPage from '../pages/IdeasPage';
import BudgetPage from '../pages/BudgetPage';
import BudgetManager from '../pages/BudgetManager';
import FestivalBudgetPage from '../pages/FestivalBudgetPage';
import AdminBudgetPage from '../pages/AdminBudgetPage';
import BudgetList from '../pages/BudgetList';
import BudgetOverviewPage from '../pages/BudgetOverviewPage';
import MarketingBudgetPage from '../pages/MarketingBudgetPage';
import TicketingBudgetPage from '../pages/TicketingBudgetPage';
import FeesBudgetPage from '../pages/FeesBudgetPage';
import ProductionBudgetPage from '../pages/ProductionBudgetPage';
import AARPage from '../pages/AARPage';
import CoolerInventoryPage from '../pages/CoolerInventoryPage';
import TaskBoardPage from '../pages/taskboard/TaskBoardPage';
import CoolerDashboardPage from '../pages/CoolerDashboardPage';
import DeletedDraftsPage from '../pages/admin/DeletedDraftsPage';
import ArtistInvitationsPage from '../pages/admin/ArtistInvitationsPage';
import ProgrammingPage from '../pages/ProgrammingPage';
import ContractsPage from '../pages/contracts';
import NewContractPage from '../pages/contracts/new';
import EditContractPage from '../pages/contracts/edit';
import TourSchedulePage from '../pages/TourSchedulePage';
import PersonnelDashboardPage from '../pages/PersonnelDashboardPage';
import GroupBudgetPage from '../pages/GroupBudgetPage';
import PostProductionPage from '../pages/PostProductionPage';
import PurchaseOrdersPage from '../pages/PurchaseOrdersPage';
import PurchaseOrderDetailPage from '../pages/PurchaseOrderDetailPage';
import InvoiceListPage from '../pages/invoices/InvoiceListPage';
import NewInvoicePage from '../pages/invoices/NewInvoicePage';
import EditInvoicePage from '../pages/invoices/EditInvoicePage';
import InvoiceDetailPage from '../pages/invoices/InvoiceDetailPage';
import RotaBuilderPage from '../pages/RotaBuilderPage';
import RotaAdmin from '../pages/RotaAdmin';
import TILManagementPage from '../pages/TILManagementPage';
import ResourceDetailPage from '../pages/ResourceDetailPage';
import DirectResourceDetail from '../components/Resources/DirectResourceDetail';
import AdminPage from '../pages/AdminPage';
import StrandsListingPage from '../pages/StrandsListingPage';
import BandDetailPage from '../pages/BandDetailPage';
import { BandViewProvider } from '../contexts/BandViewContext';
import { useAuth } from '../contexts/AuthContext';
import { UserRole } from '../types/User';
import PortfolioList from '../pages/portfolios/PortfolioList';
import PortfolioEditor from '../components/portfolio/PortfolioEditor';
import MediaLibrary from '../components/portfolio/MediaLibrary';
import PublicPortfolio from '../pages/PublicPortfolio';
import LeaveRequestsPage from '../pages/admin/LeaveRequestsPage';
import MyLeaveAndTILPage from '../pages/MyLeaveAndTILPage';
import LeaveManagementDashboard from '../pages/admin/LeaveManagementDashboard/LeaveManagementDashboard';
import StaffLeaveProfilePage from '../pages/admin/LeaveManagementDashboard/StaffLeaveProfilePage';
import DashboardPage from '../pages/DashboardPage';
import FormSubmissionSuccess from '../pages/FormSubmissionSuccess';
import ApplicationsList from '../pages/ApplicationsList';
import ApplicationDetail from '../pages/ApplicationDetail';
import ApplicationRouter from '../pages/ApplicationRouter';
import MusicianPage from '../pages/MusicianPage';
import AdminAnalyticsPage from '../pages/AdminAnalyticsPage';
import QRRedirectPage from '../pages/QRRedirectPage';
import PendingBandsPage from '../pages/admin/PendingBandsPage';


const BandDetailPageWithProvider = () => {
  const { user } = useAuth();
  const [searchParams] = useSearchParams();

  const typedUser = user ? {
    ...user,
    role: user.role as UserRole,
    createdAt: new Date(),
    updatedAt: new Date()
  } : null;

  const getInitialViewMode = (): 'admin' | 'artist' | 'strand' | 'judge' | 'public' => {
    const viewParam = searchParams.get('view');
    if (viewParam === 'public') return 'public';
    if (viewParam === 'strand') return 'strand';
    if (viewParam === 'judge') return 'judge';
    if (viewParam === 'artist') return 'artist';
    if (window.location.pathname.includes('/strands/')) return 'strand';
    if (!user) return 'public';
    if (user.role === 'admin' || user.role === 'superadmin' || user.role === 'gm') return 'admin';
    if (user.role === 'artist') return 'artist';
    return 'public';
  };

  return (
    <BandViewProvider currentUser={typedUser} initialViewMode={getInitialViewMode()}>
      <BandDetailPage />
    </BandViewProvider>
  );
};


// Wrap all components with the withAuth HOC
const ProtectedAdminAnalyticsPage = withAuth(AdminAnalyticsPage, { allowedRoles: ['admin', 'gm']});
const ProtectedDashboard: React.ComponentType = withAuth(Dashboard, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedBandListPage = withAuth(BandListPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedBandEditPage = withAuth(BandEditPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedEventListPage = withAuth(EventListPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedEventDetailPage = withAuth(EventDetailPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedEventFormPage = withAuth(EventFormPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedVenueListPage = withAuth(VenueListPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedVenueDetailPage = withAuth(VenueDetailPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedVenueFormPage = withAuth(VenueFormPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedPerformancesPage = withAuth(PerformancesPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedPerformanceDetailPage = withAuth(PerformanceDetailPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedAddEditPerformancePage = withAuth(AddEditPerformancePage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedPersonnelListPage = withAuth(PersonnelListPage, { allowedRoles: ['admin', 'gm']});
const ProtectedPersonnelDetailPage = withAuth(PersonnelDetailPage, { allowedRoles: ['admin', 'gm']});
const ProtectedPersonnelFormPage = withAuth(PersonnelFormPage, { allowedRoles: ['admin', 'gm']});
const ProtectedTitoApiTestPage = withAuth(TitoApiTestPage, { allowedRoles: ['admin', 'gm']});
const ProtectedTitoApiConnectionTest = withAuth(TitoApiConnectionTest, { allowedRoles: ['admin', 'gm']});
const ProtectedStrandListPage = withAuth(StrandListPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedStrandFormPage = withAuth(StrandFormPage, { allowedRoles: ['admin', 'gm']});
const ProtectedStrandDetailPage = withAuth(StrandDetailPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedNavigatorApplicationsList = withAuth(NavigatorApplicationsList, { allowedRoles: ['admin', 'gm']});
const ProtectedBanBamApplicationList = withAuth(BanBamApplicationList, { allowedRoles: ['admin', 'gm']});
const ProtectedBanBamApplicantDetailPage = withAuth(BanBamApplicantDetailPage, { allowedRoles: ['admin', 'gm']});
const ProtectedNavigatorApplicantDetailPage = withAuth(NavigatorApplicantDetailPage, { allowedRoles: ['admin', 'gm']});
const ProtectedUnifiedApplicationsView = withAuth(UnifiedApplicationsView, { allowedRoles: ['admin', 'gm']});
const ProtectedAdminUserManagement = withAuth(AdminUserManagement, { allowedRoles: ['admin', 'gm']});
const ProtectedPendingBandsPage = withAuth(PendingBandsPage, { allowedRoles: ['admin', 'gm']});
const ProtectedDeletedDraftsPage = withAuth(DeletedDraftsPage, { allowedRoles: ['admin', 'gm']});
const ProtectedArtistInvitationsPage = withAuth(ArtistInvitationsPage, { allowedRoles: ['admin', 'gm']});
const ProtectedAdminDomainManagementPage = withAuth(AdminDomainManagementPage, { allowedRoles: ['admin', 'gm']});
const ProtectedAllProspectsPage = withAuth(AllProspectsPage, { allowedRoles: ['admin', 'gm']});
const ProtectedExpenseListPage = withAuth(ExpenseListPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedExpenseDetailPage = withAuth(ExpenseDetailPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedExpenseForm = withAuth(ExpenseForm, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedGuidelinesManagementPage = withAuth(GuidelinesManagementPage, { allowedRoles: ['admin', 'gm']});
const ProtectedGuidelineEditor = withAuth(GuidelineEditor, { allowedRoles: ['admin', 'gm']});
const ProtectedTicketConfigPage = withAuth(TicketConfigPage, { allowedRoles: ['admin', 'gm']});
const ProtectedBandRecommendationPage = withAuth(BandRecommendationPage, { allowedRoles: ['admin', 'gm']});
const ProtectedCalendarComponent = withAuth(CalendarComponent, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedPublicStrandsPage = withAuth(PublicStrandsPage, { allowedRoles: ['admin', 'gm']});
const ProtectedMondayApiTest = withAuth(MondayApiTest, { allowedRoles: ['admin', 'gm']});
const ProtectedPublishedBandListPage = withAuth(PublishedBandListPage, { allowedRoles: ['admin', 'gm']});
const ProtectedStageDesigner = withAuth(StageDesignerPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedTicketConfigList = withAuth(TicketConfigurationList, { allowedRoles: ['admin', 'gm']});
const ProtectedTicketConfigDetail = withAuth(TicketConfigurationDetail, { allowedRoles: ['admin', 'gm']});
const ProtectedTasksPage = withAuth(TasksPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedIdeasPage = withAuth(IdeasPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedBudgetPage = withAuth(BudgetPage, { allowedRoles: ['admin', 'gm']});
const ProtectedBudgetManager = withAuth(BudgetManager, { allowedRoles: ['admin', 'gm']});
const ProtectedFestivalBudgetPage = withAuth(FestivalBudgetPage, { allowedRoles: ['admin', 'gm']});
const ProtectedAdminBudgetPage = withAuth(AdminBudgetPage, { allowedRoles: ['admin', 'gm']});
const ProtectedBudgetList = withAuth(BudgetList, { allowedRoles: ['admin', 'gm']});
const ProtectedBudgetOverviewPage = withAuth(BudgetOverviewPage, { allowedRoles: ['admin', 'gm']});
const ProtectedMarketingBudgetPage = withAuth(MarketingBudgetPage, { allowedRoles: ['admin', 'gm']});
const ProtectedAARPage = withAuth(AARPage, { allowedRoles: ['admin', 'gm']});
const ProtectedTicketingBudgetPage = withAuth(TicketingBudgetPage, { allowedRoles: ['admin', 'gm']});
const ProtectedFeesBudgetPage = withAuth(FeesBudgetPage, { allowedRoles: ['admin', 'gm']});
const ProtectedProductionBudgetPage = withAuth(ProductionBudgetPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedCoolerInventoryPage = withAuth(CoolerInventoryPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedTaskBoardPage = withAuth(TaskBoardPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedCoolerDashboardPage = withAuth(CoolerDashboardPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedProgrammingPage = withAuth(ProgrammingPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedContractsPage = withAuth(ContractsPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedNewContractPage = withAuth(NewContractPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedEditContractPage = withAuth(EditContractPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedTourSchedulePage = withAuth(TourSchedulePage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedPersonnelDashboardPage = withAuth(PersonnelDashboardPage, { allowedRoles: ['admin', 'gm']});
const ProtectedGroupBudgetPage = withAuth(GroupBudgetPage, { allowedRoles: ['admin', 'gm']});
const ProtectedPostProductionPage = withAuth(PostProductionPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedPurchaseOrdersPage = withAuth(PurchaseOrdersPage, { allowedRoles: ['admin', 'gm']});
const ProtectedPurchaseOrderDetailPage = withAuth(PurchaseOrderDetailPage, { allowedRoles: ['admin', 'gm']});
const ProtectedRotaAdmin = withAuth(RotaAdmin, { allowedRoles: ['admin', 'gm']});
const ProtectedTILManagementPage = withAuth(TILManagementPage, { allowedRoles: ['admin', 'gm']});
const ProtectedResourceDetailPage = withAuth(ResourceDetailPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedDirectResourceDetail = withAuth(DirectResourceDetail, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedStrandListingPage = withAuth(StrandsListingPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedPortfolioList = withAuth(PortfolioList, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedPortfolioEditor = withAuth(PortfolioEditor, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedMediaLibrary = withAuth(MediaLibrary, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedLeaveRequestsPage = withAuth(LeaveRequestsPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedMyLeaveAndTILPage = withAuth(MyLeaveAndTILPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedLeaveManagementDashboard = withAuth(LeaveManagementDashboard, { allowedRoles: ['admin', 'gm'] });
const ProtectedStaffLeaveProfilePage = withAuth(StaffLeaveProfilePage, { allowedRoles: ['admin', 'gm'] });
const ProtectedDashboardPage = withAuth(DashboardPage, { allowedRoles: ['admin', 'gm', 'team'] });
const ProtectedApplicationsList = withAuth(ApplicationsList, { allowedRoles: ['admin', 'gm']});
const ProtectedApplicationDetail = withAuth(ApplicationDetail, { allowedRoles: ['admin', 'gm']});
const ProtectedApplicationRouter = withAuth(ApplicationRouter, { allowedRoles: ['admin', 'gm']});



const ProgrammingProspectsWrapper = () => {
    const { strandId, prospectId } = useParams();
    
    if (!strandId) {
      return <div>Strand ID is required</div>;
    }
  
    return (
      <ProgrammingProspects
        strandId={strandId}
        strandStartDate={new Date().toISOString()} // Convert to ISO string
        strandEndDate={new Date().toISOString()} // Convert to ISO string
        onProspectsChange={() => {}}
        prospectId={prospectId}
      />
    );
  };
  const ProtectedProgrammingProspects = withAuth(ProgrammingProspectsWrapper, { allowedRoles: ['admin', 'gm', 'team'] });
  const ProtectedBandContainer = withAuth(BandContainer, { allowedRoles: ['admin', 'gm', 'team'] });
  
export const adminRoutes: RouteObject[] = [
    {
      element: <AdminLayout />,
      children: [
        { path: '/admin', element: <ProtectedDashboard /> },
        { path: '/bands', element: <PublicBandListPage /> },
        { path: '/admin/bands', element: <ProtectedBandListPage /> },
        { path: '/bandrecommendations/:id/edit', element: <ProtectedBandEditPage /> },
        { path: '/band/:id', element: <BandDetailPageWithProvider /> },
        { path: '/go/band/:bandId', element: <QRRedirectPage /> },
        { path: '/strands/:strandSlug/band/:bandId', element: <BandDetailPageWithProvider /> },
        { path: '/admin/events', element: <ProtectedEventListPage /> },
        { path: '/events/:id', element: <ProtectedEventDetailPage /> },
        { path: '/events/edit/:id', element: <ProtectedEventDetailPage /> },
        { path: '/events/new', element: <ProtectedEventFormPage /> },
        { path: '/admin/venues', element: <ProtectedVenueListPage /> },
        { path: '/admin/venues/:id', element: <ProtectedVenueDetailPage /> },
        { path: '/admin/venues/:id/edit', element: <ProtectedVenueFormPage /> },
        { path: '/admin/venues/new', element: <ProtectedVenueFormPage /> },
        { path: '/admin/performances', element: <ProtectedPerformancesPage /> },
        { path: '/admin/performances/edit/:id', element: <ProtectedAddEditPerformancePage /> },
        { path: '/admin/resources/:performanceId', element: <ProtectedResourceDetailPage /> },
        { path: '/admin/performances/:id', element: <ProtectedPerformanceDetailPage /> },
        { path: '/admin/performances/new', element: <ProtectedAddEditPerformancePage /> },
        { path: '/admin/personnel', element: <ProtectedPersonnelListPage /> },
        { path: '/admin/personnel/edit/:id', element: <ProtectedPersonnelFormPage /> },
        { path: '/admin/personnel/:id', element: <ProtectedPersonnelDetailPage /> },
        { path: '/admin/personnel/new', element: <ProtectedPersonnelFormPage /> },
        { path: '/admin/personnel/dashboard/', element: <ProtectedPersonnelDashboardPage /> },
        { path: "/submit", element: <ProtectedBandRecommendationPage />},
        { path: '/admin/sales', element: <ProtectedTitoApiTestPage /> },
        { path: '/admin/admin', element: <AdminPage /> },
        { path: '/admin/tito-connection', element: <ProtectedTitoApiConnectionTest /> },
        { path: '/admin/strands', element: <ProtectedStrandListPage /> },
        { path: '/strands/new', element: <ProtectedStrandFormPage /> },
        { path: '/strands/edit/:id', element: <ProtectedStrandFormPage /> },
        { path: '/admin/strands/:id', element: <ProtectedStrandDetailPage /> },
        { path: '/admin/strands/live', element: <ProtectedStrandListingPage /> },
        { path: '/banbam', element: <BanBamPage /> },
        { path: '/navigator', element: <FormPage /> },
        { path: '/banbamfaq', element: <BanBam2025Announcement /> },
        { path: '/admin/applications', element: <ProtectedApplicationsList /> },
        { path: '/admin/navigator-applications', element: <ProtectedNavigatorApplicationsList /> },
        { path: '/admin/banbam-applications', element: <ProtectedBanBamApplicationList /> },
        { path: '/banbam-applications/:id', element: <ProtectedBanBamApplicantDetailPage /> },
        { path: '/navigator-applications/:id', element: <ProtectedNavigatorApplicantDetailPage /> },
        { path: '/admin/applications/:id', element: <ProtectedApplicationRouter /> },
        { path: '/admin/users', element: <ProtectedAdminUserManagement /> },
        { path: '/admin/pending-bands', element: <ProtectedPendingBandsPage /> },
        { path: '/admin/deleted-drafts', element: <ProtectedDeletedDraftsPage /> },
        { path: '/admin/artist-invitations', element: <ProtectedArtistInvitationsPage /> },
        { path: '/admin/domains', element: <ProtectedAdminDomainManagementPage /> },
        { path: '/admin/form-submission-success/:slug', element: <FormSubmissionSuccess /> },
        { path: '/form-submission-success/:slug', element: <FormSubmissionSuccess /> },
        { path: '/admin/prospects', element: <ProtectedAllProspectsPage /> },
        { path: '/admin/prospects/:strandId/new', element: <ProtectedProgrammingProspects /> },
        { path: '/admin/prospects/:strandId/edit/:prospectId', element: <ProtectedProgrammingProspects /> },
        { path: '/admin/expenses', element: <ProtectedExpenseListPage /> },
        { path: '/admin/expenses/:id', element: <ProtectedExpenseDetailPage /> },
        { path: '/admin/expenses/new', element: <ProtectedExpenseForm /> },
        { path: '/admin/expenses/:id/edit', element: <ProtectedExpenseForm /> },
        { path: '/guidelines', element: <ProtectedGuidelinesManagementPage /> },
        { path: '/guidelines/:id', element: <ProtectedGuidelineEditor /> },
        { path: '/guidelines/:id/edit', element: <ProtectedGuidelineEditor /> },
        { path: '/strands/guidelines/new', element: <ProtectedGuidelineEditor /> },
        { path: '/tix', element: <ProtectedTicketConfigPage /> },
        { path: '/tix-list', element: <ProtectedTicketConfigList /> },
        { path: '/tix-list/:id', element: <ProtectedTicketConfigDetail /> },
        { path: '/tix-list/:id/edit', element: <ProtectedTicketConfigPage />},
        { path: '/calendar', element: <ProtectedCalendarComponent /> },
        { path: '/publicstrands', element: <ProtectedPublicStrandsPage /> },
        { path: '/monday', element: <ProtectedMondayApiTest /> },
        { path: '/tasks', element: <ProtectedTasksPage /> },
        { path: '/admin/ideas', element: <ProtectedIdeasPage /> },
        { path: '/admin/budget', element: <ProtectedBudgetPage /> },
        { path: '/admin/budget-manager/', element: <ProtectedBudgetManager /> },
        { path: '/admin/budget-dashboard', element: <ProtectedGroupBudgetPage /> },
        { path: '/admin/group-budget', element: <ProtectedFestivalBudgetPage /> },
        { path: '/admin/group-budget/:id', element: <ProtectedFestivalBudgetPage /> },
        { path: '/admin/admin-budget', element: <ProtectedAdminBudgetPage /> },
        { path: '/admin/master-budget-list', element: <ProtectedBudgetList /> },
        { path: '/admin/aar', element: <ProtectedAARPage /> },
        { path: 'admin/budget/:id', element: <ProtectedBudgetPage />},
        { path: '/admin/budget-overview', element: <ProtectedBudgetOverviewPage />},
        { path: '/admin/marketing-budget', element: <ProtectedMarketingBudgetPage />},
        { path: '/admin/ticketing-budget', element: <ProtectedTicketingBudgetPage />},
        { path: '/admin/fees-budget', element: <ProtectedFeesBudgetPage />},
        { path: '/admin/production-budget', element: <ProtectedProductionBudgetPage />},
        { path: '/admin/contracts', element: <ProtectedContractsPage />},
        { path: '/admin/contracts/new', element: <ProtectedNewContractPage />},
        { path: '/admin/contracts/edit/:id', element: <ProtectedEditContractPage />},
        { path: '/strands/:strandSlug', element: <ProtectedPublishedBandListPage />},
        { path: '/stage-designer', element: <StageDesignerPage />},
        { path: '/artist/stage-plots',          element: <StagePlotsListPage /> },
        { path: '/artist/stage-plots/new',      element: <StageDesignerPage /> },
        { path: '/artist/stage-plots/:id/edit', element: <StageDesignerPage /> },
        { path: '/artist/stage-plots/:id/view', element: <StagePlotPDF /> },
        { path: '/guidelines/strand/:strandSlug', element: <GuidelineViewPage /> },
        { path: "/musicadmin", element: <MusicAdminPage />},
        { path: "/dynamicform", element: <DynamicForm formSchema={banBamFormSchema}/>},
        { path: '/formbuilder', element: <FormBuilder /> },
        { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
        { path: '/artist/signup', element: <ArtistSignupPage /> },
        { path: '/artist/dashboard', element: <ArtistDashboard />},
        { path: '/artist/profile', element: <ArtistProfileEditPage />},
        { path: '/investor/dashboard', element: <InvestorDashboard /> },
        { path: '/form/:slug', element: <DynamicFormPage /> },
        { path: '/submission-success', element: <SubmissionSuccess /> },
        { path: '/admin/cooler', element: <ProtectedCoolerDashboardPage /> },
        { path: '/admin/inventory', element: <ProtectedCoolerInventoryPage /> },
        { path: '/admin/taskboard', element: <ProtectedTaskBoardPage /> },
        { path: '/admin/programming', element: <ProtectedProgrammingPage /> },
        { path: '/admin/performances/schedule', element: <ProtectedTourSchedulePage /> },
        { path: '/admin/performances/post-production', element: <ProtectedPostProductionPage /> },
        { path: '/admin/performances/post-production/:id', element: <ProtectedPostProductionPage />},
        { path: '/admin/purchase-orders', element: <ProtectedPurchaseOrdersPage /> },
        { path: '/admin/purchase-orders/:id', element: <ProtectedPurchaseOrderDetailPage /> },
        { path: '/admin/invoices', element: <InvoiceListPage /> },
        { path: '/admin/invoices/new', element: <NewInvoicePage /> },
        { path: '/admin/invoices/edit/:id', element: <EditInvoicePage /> },
        { path: '/admin/invoices/:id', element: <InvoiceDetailPage /> },
        { path: '/admin/rota', element: <RotaBuilderPage /> },
        { path: '/admin/portfolios', element: <ProtectedPortfolioList /> },
        { path: '/admin/portfolios/:id/edit', element: <ProtectedPortfolioEditor /> },
        { path: '/portfolio/:slug', element: <PublicPortfolio /> },
        { path: '/admin/media', element: <ProtectedMediaLibrary /> },
        { path: '/admin/rotakk', element: <ProtectedRotaAdmin /> },
        { path: '/admin/til', element: <ProtectedTILManagementPage /> },
        { path: '/admin/time', element: <ProtectedLeaveRequestsPage /> },
        { path: '/admin/resources/view/:resourceId', element: <ProtectedDirectResourceDetail /> },
        { path: '/admin/my-leave-and-til', element: <ProtectedMyLeaveAndTILPage /> },
        { path: '/admin/leave-management', element: <ProtectedLeaveManagementDashboard /> },
        { path: '/admin/leave-management/staff/:id', element: <ProtectedStaffLeaveProfilePage /> },
        { path: '/admin/performances/review', element: <ProtectedDashboardPage /> },
        { path: '/musician/:name', element: <MusicianPage /> },
        { path: '/admin/analytics', element: <ProtectedAdminAnalyticsPage /> },

     ],
    },
  ];